module.exports = "https://static.moomoo.com/components/common-stock-analysis-advisor/images/bg.7144963aab.png";